import React from "react"
import PaymentsTable from "./PaymentsTable"
import {useParams} from "react-router-dom"
import {FilterKey} from "types/filter"

const PaymentsTab = () => {
    const params = useParams<{profileId: string}>()
    const profileId = +params.profileId

    return <PaymentsTable profileId={profileId} filterKey={FilterKey.StudentAccountStudentPayments} />
}

export default PaymentsTab
